"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var modal_title_png_1 = __importDefault(require("images/fifth_anniversary_modal/modal-title.png"));
var modal_img_png_1 = __importDefault(require("images/fifth_anniversary_modal/modal-img.png"));
var LOCAL_STORAGE_KEY = 'fifth_anniversary_modal_opened_at';
var FifthAnniversaryModal = /** @class */ (function (_super) {
    __extends(FifthAnniversaryModal, _super);
    function FifthAnniversaryModal(props) {
        var _this = _super.call(this, props) || this;
        _this.modalVisible = false;
        _this.handleClose = function () {
            _this.modalVisible = false;
        };
        _this.handleClickCampaignButton = function () {
            var lpPagePath = _this.props.lpPagePath;
            google_analytics_manager_1.default.postGAEvent('PC_popup_campaign_5thanniversary', 'click', 'ヒカカク5周年記念キャンペーンLP');
            window.open(lpPagePath, '_blank');
        };
        if (!localStorage.getItem(LOCAL_STORAGE_KEY)) {
            _this.modalVisible = true;
            localStorage.setItem(LOCAL_STORAGE_KEY, Date());
        }
        return _this;
    }
    FifthAnniversaryModal.prototype.render = function () {
        return (react_1.default.createElement(react_responsive_modal_1.default, { onClose: this.handleClose, open: this.modalVisible },
            react_1.default.createElement("img", { className: "fifthAnniversaryLp-Modal_TitleImage lazyload", src: modal_title_png_1.default, alt: "\u30D2\u30AB\u30AB\u30AF\uFF01\uFF15\u5468\u5E74\u8A18\u5FF5\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3" }),
            react_1.default.createElement("div", { className: "fifthAnniversaryLp-Modal_TitleText" }, "\u67FB\u5B9A\u5F8C\u306B\u3054\u5FDC\u52DF\u3055\u308C\u305F\u65B9\u306E\u4E2D\u304B\u3089\u62BD\u9078\u3067Amazon\u30AE\u30D5\u30C8\u5238\u3092\u30D7\u30EC\u30BC\u30F3\u30C8\uFF01"),
            react_1.default.createElement("img", { className: "fifthAnniversaryLp-Modal_MainImage lazyload", src: modal_img_png_1.default, alt: "\u67FB\u5B9A\u3057\u3066\u5FDC\u52DF\u3059\u308B\u3060\u3051\uFF01" }),
            react_1.default.createElement("button", { className: "sw-Button sw-Button-cta fifthAnniversaryLp-Modal_Button", onClick: this.handleClickCampaignButton }, "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u8A73\u7D30\u3078")));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], FifthAnniversaryModal.prototype, "modalVisible", void 0);
    FifthAnniversaryModal = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], FifthAnniversaryModal);
    return FifthAnniversaryModal;
}(react_1.default.Component));
exports.default = FifthAnniversaryModal;
